export default __webpack_public_path__ + "static/media/arrow.167739e7.svg";